module.exports = __webpack_public_path__ + "img/logo-horizontal-dark-wt-gioco-plus.2d89ad73.png";